import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "native-image-picker"
  static targets = ["form", "fileInput", "cameraInput", "libraryInput"]

  connect () {
    super.connect()
  }

  openCamera (event) {
    event.preventDefault()
    if (this.enabled) {
      this.#pickImage("openCamera")
    } else if (this.hasCameraInputTarget) {
      this.cameraInputTarget.click()
    }
  }

  openLibrary (event) {
    event.preventDefault()
    if (this.enabled) {
      this.#pickImage("openLibrary")
    } else if (this.hasLibraryInputTarget) {
      this.libraryInputTarget.click()
    }
  }

  submitOnSelect () {
    if (this.formTarget.requestSubmit) {
      this.formTarget.requestSubmit()
    } else {
      this.formTarget.submit()
    }
  }

  #pickImage (eventName) {
    this.send(eventName, {}, (message) => {
      const { base64, contentType, filename } = message.data
      if (!base64) return

      const file = this.#base64ToFile(base64, contentType, filename)
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      this.fileInputTarget.files = dataTransfer.files
      this.submitOnSelect()
    })
  }

  #base64ToFile (base64, contentType, filename) {
    const binary = atob(base64)
    const bytes = new Uint8Array(binary.length)

    for (let index = 0; index < binary.length; index++) {
      bytes[index] = binary.charCodeAt(index)
    }

    return new File([bytes], filename || "image.jpg", { type: contentType || "image/jpeg" })
  }
}
